import { createSlice } from '@reduxjs/toolkit';
import { globalApi } from '@store/rtk/global';
import { idType, selectItemType } from '@src/types';
import { TableData } from '@uikit/Tables/types';
import { TABLE_COLUMNS } from '@uikit/Tables/columns';

type ContactsItemDataType = {
  id: idType;
  firstName: string;
  lastName: string;
  contactExt: string;
  contact: string;
  secContactExt: string;
  secContact: string;
  fax: string;
  sms: boolean;
  email: string;
  userImg: string;
  userSpecial: string;
  verifyEmail: boolean;
  toggle: boolean;
  active_indicator: boolean;
  aor?: boolean;
  consentReceived?: boolean;
};

type AuthContactsType = {
  name: string;
  contactsData: {
    content: Array<ContactsItemDataType>;
    last: number;
    page: number;
    size: number;
    totalElements: number;
    totalPages: number;
  } | null;
  contactsTableData: TableData;
  contactData: any;
  memberModalsContactSelect: Array<selectItemType & { image: string }> | null;
};

const mapContactRow = (contact: any, isMemberContact: boolean) => ({
  ...contact,
  isMemberContact,
  nameForTable: {
    image: contact?.image,
    firstName: contact?.firstName,
    lastName: contact?.lastName,
    relation: contact?.relation?.value || '',
  },
  typeForTable: contact?.type,
  statusForTable: contact?.activeIndicator,
});

const { contactsTableColumns, contactsTableFiltrationColumns } = TABLE_COLUMNS;

const initialState: AuthContactsType = {
  name: '',
  contactsData: null,
  contactsTableData: {
    columns: contactsTableColumns,
    columnsForFilter: contactsTableFiltrationColumns,
    rows: [],
    size: 5,
  },
  memberModalsContactSelect: null,
  contactData: null,
};

export const authContactsSlice = createSlice({
  name: 'authContacts',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addMatcher(
        globalApi.endpoints.getUserContacts.matchFulfilled,
        (state, { payload }) => {
          const lastData = state.contactsData;
          const body = {
            ...payload,
            content: payload.content || [],
            requestTablePageChange: globalApi.endpoints.getUserContacts,
            filter: payload.filter,
            requestForInfiniteScroll: globalApi.endpoints.getUserContacts,
          };
          state.contactsData = body;
          if (payload?.content && payload?.page !== 0) {
            state.contactsData = {
              ...body,
              content: [
                ...(lastData ? lastData.content : []),
                ...payload.content,
              ],
            };
          }
        }
      )
      .addMatcher(
        globalApi.endpoints.getUserContacts.matchFulfilled,
        (state, { payload }) => {
          state.contactsTableData = {
            ...state.contactsTableData,
            rows: [
              ...(payload.memberContact
                ? [mapContactRow(payload.memberContact, true)]
                : []),
              ...(payload.content && Array.isArray(payload.content)
                ? payload?.content?.map((el) => mapContactRow(el, false))
                : []),
            ],
            ...payload,
            requestTablePageChange: globalApi.endpoints.getUserContacts,
            requestStatusChange: globalApi.endpoints.createOrUpdateUserContacts,
          };
        }
      )
      .addMatcher(
        globalApi.endpoints.getMemberModalsContactSelect.matchFulfilled,
        (state, { payload }) => {
          state.memberModalsContactSelect = payload;
        }
      )
      .addMatcher(
        globalApi.endpoints.getUserContactById.matchFulfilled,
        (state, { payload }) => {
          state.contactData = payload;
        }
      );
  },
});

export const selectContacts = (state) => state.authContacts;
export const authContactsReducer = authContactsSlice.reducer;
